export default {
  methods: {
    isVisible(block) {
      return !block.guestOnly || !this.$auth.user; // de Morgan's Law :D
    },
  },
};
